import routes from 'app/routes'

export const isAuthRoute = (pathname: string): boolean => {
  const authRoutes = Object.values(routes.auth)

  return authRoutes.includes(pathname)
}
